import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import ReactResizeDetector from 'react-resize-detector';
import styles from './ProjectTags.css';

const TAGS_IN_ONE_COL = 6;

class ProjectTags extends Component {
  static propTypes = {
    tags: PropTypes.arrayOf(PropTypes.object).isRequired,
    onHeightCalculated: PropTypes.func.isRequired,
    activeTag: PropTypes.string,
    langIsEn: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    this.onHeightCalculated()
  }

  onResize() {
    this.onHeightCalculated()
  }

  onHeightCalculated() {
    const { onHeightCalculated } = this.props;
    const height = this.h1Tags.clientHeight;
    onHeightCalculated(height + 211); //211 = 143 + 68
  }

  renderTags(tags) {
    const { activeTag, langIsEn } = this.props;

    return tags.map((tag, idx) =>
      <h1
        key={idx}
        className={classnames(
          { [styles.engTags]: langIsEn },
          { [styles.chtTags]: !langIsEn }
        )}
      >
        <Link to={`/projects/tags/${encodeURIComponent(tag.engName)}`}>
          {langIsEn &&
            <span className={classnames({ [styles.active]: tag.engName === activeTag })}>
              {tag.engName}
            </span>
          }
          {!langIsEn &&
            <span className={classnames({ [styles.active]: tag.engName === activeTag })}>
              <span className={styles.engTag}>{tag.engName}</span> <span className={styles.chtTag}>{tag.chtName}</span>
            </span>
          }
        </Link>
      </h1>
    );
  }

  render() {
    const { tags } = this.props;

    return (
      <section
        className='container'
        ref={(h1) => { this.h1Tags = h1; }}
      >
        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize.bind(this)} />
        <div className={styles.tagsContainer}>
          <div
            className={classnames('col--m-5of12', styles.tags)}
          >
            {this.renderTags(tags.slice(0, TAGS_IN_ONE_COL))}
          </div>
          {tags.length > TAGS_IN_ONE_COL &&
            <div
              className={classnames('col--m-4of12', styles.tags)}
            >
              {this.renderTags(tags.slice(TAGS_IN_ONE_COL))}
            </div>
          }
        </div>
      </section>
    );
  }
}

export default ProjectTags;



// WEBPACK FOOTER //
// ./src/components/project-tags/ProjectTags.js